import React from 'react';
import pt from 'prop-types';
import Icon from 'components/icon';
import {
  DropdownMenu,
  DropdownMenuItem,
  DropdownMenuSeparator,
} from 'components/dropdown-menu';
import AppReviewCommentForm from './comment-form';

import AppReviewComment from './comment';

export default class AppReviewThread extends React.PureComponent {
  static contextTypes = {
    user: pt.object.isRequired,
  };

  static propTypes = {
    version: pt.string.isRequired,
    // Absent until the review of this version is opened
    thread: pt.object,
    canAddInternal: pt.bool,
    onCreateComment: pt.func,
    onUpdateComment: pt.func,
    onDeleteComment: pt.func,
  };

  constructor(props) {
    super(props);

    this.state = { editCommentId: null };
  }

  onEditComment(id) {
    this.setState({ editCommentId: id });
  }

  onRemoveComment(comment) {
    this.props.onDeleteComment(comment);
  }

  onSubmitCommentEdit = async (values) => {
    const { editCommentId } = this.state;

    await this.props.onUpdateComment(editCommentId, values);

    this.setState({ editCommentId: null });
  };

  // A version carries one thread, and it is what the partner answers, so the
  // comment opening it can never be withheld from them
  canBeInternal(comment) {
    return this.props.canAddInternal && Boolean(comment?.top_id);
  }

  renderCommentActions(comment) {
    if (this.context.user.id !== comment.user_id) {
      return null;
    }

    return (
      <DropdownMenu
        contentRest={{ side: 'bottom', align: 'start', sideOffset: 6 }}
        contentClassName="dropdown-menu-content review-comments--actions-menu"
        triggerClassName="review-comments--comment--actions"
        triggerChildren={<Icon fa="ellipsis-h" />}
      >
        <DropdownMenuItem onSelect={() => this.onEditComment(comment.id)}>
          Edit comment
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem onSelect={() => this.onRemoveComment(comment)}>
          <span className="danger">Delete comment</span>
        </DropdownMenuItem>
      </DropdownMenu>
    );
  }

  renderComment = (comment) => {
    const isEditing = this.state.editCommentId === comment.id;

    return (
      <AppReviewComment
        key={comment.id}
        comment={comment}
        actions={this.renderCommentActions(comment)}
      >
        {isEditing && (
          <AppReviewCommentForm
            label="Edit comment"
            defaultValues={comment}
            canAddInternal={this.canBeInternal(comment)}
            onSubmitComment={this.onSubmitCommentEdit}
          />
        )}
      </AppReviewComment>
    );
  };

  render() {
    const { version, thread, canAddInternal, onCreateComment } = this.props;
    const comments = thread ? [thread, ...thread.replies] : [];
    // Without a thread the composer opens the review rather than answering it
    const canReplyInternally = canAddInternal && Boolean(thread);

    return (
      <div className="review-comments--thread">
        <div className="review-comments--thread--header">v{version}</div>
        {comments.length > 0 && (
          <div className="review-comments--thread--comments">
            {comments.map(this.renderComment)}
          </div>
        )}
        <div className="review-comments--thread--reply">
          <AppReviewCommentForm
            label="Reply"
            topComment={thread}
            canAddInternal={canReplyInternally}
            onSubmitComment={onCreateComment}
          />
        </div>
      </div>
    );
  }
}
